@if (showIntro) {
<app-intro-overlay (done)="hideIntro()"></app-intro-overlay>

}

<section class="auth-section">
  <header class="header">
    <section [class.show]="!showIntro" routerLink="/" class="logo-wrapper">
      <img class="logo" src="assets/icons/logo.svg" alt="Logo" />
      <div class="text-mask">
        <span class="text">DABubble</span>
      </div>
    </section>

    <!-- Desktop -->
    @if (isLogin()) {
    <hgroup class="signup-text signup-text--desktop">
      <p>Neu bei DABubble?</p>
      <a routerLink="/signup" class="nav-link">Konto erstellen</a>
    </hgroup>
    }
  </header>

  <main class="content">
    <router-outlet></router-outlet>
  </main>

  <!-- Mobile -->
  @if (isLogin()) {
  <hgroup class="signup-text signup-text--mobile">
    <p>Neu bei DABubble?</p>
    <a routerLink="/signup" class="nav-link nav-link--primary">Konto erstellen</a>
  </hgroup>
  }

  <footer class="footer">
    @if (isAuth()) {
    <a routerLink="/imprint">Impressum</a>
    <a routerLink="/privacy-policy">Datenschutz</a>
    }
  </footer>
</section>
